import { cameraApiRequest } from './cameraApiRequest';

/**
 * A camera's motion clips that started in `[from, to)` (ISO instants, at
 * most 31 days), newest first: `{ clips }`. Each clip carries a signed
 * `thumbnailUrl` (about 10 minutes) and no bucket keys. Needs
 * `cameras_view_recordings`.
 */
export const getCameraClips = ({
  projectId,
  cameraId,
  from,
  to,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'GET',
    apiPath: `projects/${projectId}/cameras/${cameraId}/clips?from=${encodeURIComponent(
      from
    )}&to=${encodeURIComponent(to)}`,
    activeEmployerInfo,
  });
